import React, { Component } from 'react';
import './app.scss';
import './rwttabs.scss';
import { Content } from 'carbon-components-react/lib/components/UIShell';
import IAGHeader from './components/IAGHeader';
import { Outlet } from 'react-router-dom';

class App extends Component {
  render() {
    return (
      <>
        <IAGHeader />
        <Content>
          <div className="bx--row">
            <section className="bx--offset-lg-3 bx--col-lg-13">
              <Outlet />
            </section>
          </div>
        </Content>
      </>
    );
  }
}

export default App;















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































